

















import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

// The @Component decorator indicates the class is a Vue component
@Component({})
export default class MultiplierFlow extends Vue {
  @Prop()
  public payload?: number;

  multiplier = 1;

  public created() {
  }

  async another(): Promise<void> {
    await this.$flows.start('red', 'foo')
    console.log("Red flow (launched from multiply flow) was closed");
  }
  cancel(): void {
    this.$emit('close-flow')
  }
  confirm(): void {
    this.$emit('close-flow', this.multiplier * this.payload!);
  }
}
